import React from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "../entities/formTemplateDataType";
import { SubSectionComponent } from "../runtimeComponent/SubSectionComponent";
import { Heading1, Heading4, colour } from "../theme";
import { CMADashboardComponent } from "../runtimeComponent/subComponent/cma/CMADashboardComponent";
import { CMAReviewComponent } from "../runtimeComponent/subComponent/cma/CMAReviewComponent";
import { ErrorAlertComponent } from "../runtimeComponent/odsCalloutBox/ErrorAlertComponent";
import { SuccessAlertComponent } from "../runtimeComponent/odsCalloutBox/SuccessAlertComponent";
import { parseJson, stringifyJson } from "../utilities/JsonUtils";
import { Helmet } from "react-helmet";
import CMAUtils from "../utilities/CMAUtils";
import { TemplateStatus, TOKEN_TYPE } from "../entities/Constants";
import { SelectButton } from "primereact/selectbutton";
import SessionStorageService from "../services/SessionStorageService";
import URLUtils from "../utilities/URLUtils";
import axios from "axios";
import * as CircularJSON from 'circular-json';
import { formatDateCustom } from "../utilities/DateUtils";
import { Toast } from 'primereact/toast';
import success from "src/theme/icons/success";

interface Props {
    programContainer: ProgramContainer;
    isEng: boolean;
    callback: (programContainer: ProgramContainer) => void;
    callbackValidate?: (errors: any) => void;
}

interface State {
    stepperIndex: number;
    fromReview: boolean;
    showError: boolean;
    showConfirmation: boolean;
    initialSubsec: FormSubSections;
    subsecBool: boolean;
    isCSD: boolean;
    CSDAssessments: any[];
    assessmentListOption: string;
}

export class CMAFormComponent extends React.Component<Props, State> {
    timer: NodeJS.Timeout;
    growl: Toast;

    constructor(props) {
        super(props);
        this.state = {
            stepperIndex: 0,
            fromReview: false,
            showError: false,
            showConfirmation: false,
            initialSubsec: null,
            subsecBool: true,
            isCSD: false,
            CSDAssessments: [],
            assessmentListOption: "All",
        }
    }
    dashboardIndex = 3;
    reviewPageIndex = 4;
    componentDidUpdate = (prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any)=> {
        if (this.state.stepperIndex !== prevState.stepperIndex) window.scrollTo({ top: 0, behavior: "instant" });
        if (this.state.stepperIndex == 1 && prevState.stepperIndex == 0) {
            const checkboxEle = this.props.programContainer.ListOfFormSections[0].ListOfFormSubSections[0].ListOfFormSectionElements[1];
            if (!checkboxEle.Value || checkboxEle.Value != "Y") {
                checkboxEle.Valid = false;
                checkboxEle.Touched = true;
                this.setState({ showError: true, stepperIndex: 0 });
            }
        }
    }

    componentDidMount=async ()=> {
        this.timer = setInterval(() => {
            CMAUtils.saveCMA(this.props.programContainer).then(success=>{
                if(success)
                    this.displayToast();
            });
            console.log(Date.now(), this.props.programContainer);
        }, 600000); // 60000ms = 1 minute
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        };
        const api = URLUtils.concatUrls('/data/case/form-data/csd');
        try {
            let response = await axios.get(api, { withCredentials: true, headers: headers });

            if (Array.isArray(response.data)) {
                let isCSD = response.data.length > 0;
                this.setState({CSDAssessments: response.data, isCSD: isCSD, stepperIndex: isCSD ? 2 : 0}); // Ensure data is an array before setting state
            } else {
                console.error("Expected an array but got:", response.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }

    componentWillUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }


    stepIndicator = () => {
        return (
            <div className="ontario-step-indicator">
                <div className="ontario-row">
                    <div className="ontario-small-12">
                        <div className="ontario-step-indicator--with-back-button">
                            <button className="ontario-button ontario-button--tertiary"
                                onClick={() => {
                                    this.setState({ stepperIndex: this.dashboardIndex, fromReview: false });
                                    CMAUtils.saveCMA(this.props.programContainer).then(success=>{
                                        if(success)
                                            this.displayToast();
                                    });
                                }}>
                                <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-chevron-left"></use>
                                </svg>Back to dashboard
                            </button>
                            <span className="ontario-h4">{this.stepIndicatorTitle(this.state.stepperIndex)}</span>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
        );
    }

    stepIndicatorTitle = (sectionIndex: number) => {
        if (sectionIndex == this.reviewPageIndex) return "";
        let title = "";
        const categoryOrder = sectionIndex - this.reviewPageIndex;
        const funcList = this.props.programContainer.CMATemplateList[0].Functions;
        let firstCategory = 1;
        funcList.forEach(f => {
            const firstOfNext = firstCategory + f.CategoryDetailList.length;
            if (firstCategory <= categoryOrder && categoryOrder < firstOfNext)
                title = "Step " + String(categoryOrder - firstCategory + 1) + " of " + f.CategoryDetailList.length;
            firstCategory = firstOfNext;
        });
        return title;
    }

    downloadCSV = () => {
        let csvData = "Template,Assessment name,Status,Organization,Date issued,Overall score\r\n";
        let assessmentList = this.state.CSDAssessments;
        if (this.state.assessmentListOption == "Action required") {
            assessmentList = this.state.CSDAssessments.filter((a) => a.status == TemplateStatus.SUBMITTED);
        }
        assessmentList.forEach((a) => {
            csvData += a.template + ",";
            csvData += a.assessmentName + ",";
            csvData += (a.status == TemplateStatus.SUBMITTED ? "Approved & OPS Submitted" : a.status) + ",";
            csvData += a.organizationName + ",";
            csvData += formatDateCustom(a.createdDate) + ",";
            csvData += (a.score || "N/A") + "\r\n";
        })

        let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
        let dwldLink = document.createElement("a");
        let url = URL.createObjectURL(blob);
        let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
        if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
        dwldLink.setAttribute("target", "_blank");
        }
        dwldLink.setAttribute("href", url);
        dwldLink.setAttribute("download", "report.csv");
        dwldLink.style.visibility = "hidden";
        document.body.appendChild(dwldLink);
        dwldLink.click();
        document.body.removeChild(dwldLink);
    }

    generateCSDTable = () => {
        let htmlString = [];
        let p = this.props.programContainer;
        let assessmentList = this.state.CSDAssessments;
        if (this.state.assessmentListOption == "Action required") {
            assessmentList = this.state.CSDAssessments.filter((a) => a.status == TemplateStatus.SUBMITTED);
        }
        assessmentList.forEach((a, index) => {
            if ((a.status == TemplateStatus.SUBMITTED || a.status == TemplateStatus.COMPLETED) && !a.score) {
                this.findOverallScore(a.template, a.orgId, index, a.status);
            }
            htmlString.push(
                <tr>
                    <th scope="row"><a style={a.status!=TemplateStatus.SUBMITTED ? {color: colour.hintTextGrey} : {}} onClick={async () => {
                        if (a.status != TemplateStatus.SUBMITTED) return;
                        p.Template = a.template;
                        p.orgId=a.orgId;
                        p.userRole="CSA";
                        p.organizationName=a.organizationName;
                        CMAUtils.generateCMASection(p);
                        await CMAUtils.retrieveFormData(p);
                        this.setState({stepperIndex: this.dashboardIndex})
                    }}>
                        {a.formattedTemplateAssessment}
                    </a></th>
                    <td>{a.status == TemplateStatus.SUBMITTED ? "Approved & OPS Submitted" : a.status}</td>
                    <td>{a.organizationName}</td>
                    <td>{formatDateCustom(a.createdDate)}</td>
                    <td>{(a.status == TemplateStatus.SUBMITTED || a.status == TemplateStatus.COMPLETED) && a.score  ? a.score : "N/A"}</td>
                </tr>
            );
        })
        return htmlString;
    }

    findOverallScore = (template: string, orgId: string, assessmentIndex: number, status: string) => {
        let result = 0;
        const token = SessionStorageService.getAccessToken(TOKEN_TYPE.API);
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        let api = URLUtils.concatUrls("data/case/" + template +"/" + orgId + "/" + status);
        axios.get((api), {
            withCredentials: true,
            headers: headers
        }).then(response => {
            let parsedFormValue = CircularJSON.parse(response.data.formValue);
            let scoreSum = 0;
            let questionsCount = 0;
            for (let key in parsedFormValue) {
                if (typeof(parsedFormValue[key]) == "object" && parsedFormValue[key]) {
                    questionsCount += Object.keys(parsedFormValue[key]).length;
                    scoreSum = Object.keys(parsedFormValue[key]).reduce((acc, k) => acc + parsedFormValue[key][k]["level"], scoreSum);
                }
            }
            let assessmentList = this.state.CSDAssessments;
            assessmentList[assessmentIndex]["score"] = Math.trunc((scoreSum/questionsCount)*10)/10;
            this.setState({CSDAssessments: assessmentList});
        });
    }

    render() {
        let p = this.props.programContainer;
        const cmaRole = this.props.programContainer.userRole?.split(',')?.reduce((finalRole, role) => finalRole === 'A' ? finalRole : role.charAt(0), '');
        const currentSec = p.ListOfFormSections[this.state.stepperIndex];

        let htmlString = [];

      
        htmlString.push(
            <>  {/* @ts-ignore */}
                <Helmet><title>OPS Cyber Maturity Assessment Tool</title></Helmet>
            </>
        );

        if (!this.props.isEng) {
            return <Heading4 style={{textAlign: 'center'}}>Page Under Construction</Heading4>;
        }

        if (this.state.isCSD && this.state.stepperIndex == 2) {
            return <>
                <Heading1>Assessment Dashboard</Heading1>
                <SelectButton value={this.state.assessmentListOption} options={['All', 'Action required']}
                    onChange={(e) => this.setState({assessmentListOption: e.value})}/>
                <div className="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
                    <div className="ontario-table-scroll--wrapper">
                        <div className="ontario-table-scroll--div"></div>
                    </div>
                    <div className="ontario-table-div">
                        <table>
                            <caption>Received Assessments</caption>
                            <thead>
                                <tr>
                                    <th scope="col">
                                        Display Name/ID
                                    </th>
                                    <th scope="col">
                                        Status
                                    </th>
                                    <th scope="col">
                                        Organization
                                    </th>
                                    <th scope="col">
                                        Date Issued
                                    </th>
                                    <th scope="col">
                                        Overall Score
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.generateCSDTable()}
                            </tbody>
                        </table>
                    </div>
                </div>
                <button className="ontario-button ontario-button--primary" onClick={() => this.downloadCSV()}>Export report</button>
            </>;
        } 

        // back to dashboard breadcrumb
        if (this.state.stepperIndex > this.dashboardIndex && !this.state.showConfirmation) {
            htmlString.push(this.stepIndicator());
        }

        // function title on question page
        if (this.state.stepperIndex >= this.dashboardIndex) {
            if (p.Name != "Cyber Maturity Assessment Tool\n" + currentSec?.ENUDescription) {
                p.Name = "Cyber Maturity Assessment Tool\n" + currentSec?.ENUDescription;
                this.props.callback(p);
            }
        }
        else {
            if (p.Name != "Cyber Maturity Assessment Tool") {
                p.Name = "Cyber Maturity Assessment Tool";
                this.props.callback(p);
            }
        }

        if (this.state.showConfirmation) {
            htmlString.push(
                <SuccessAlertComponent bodyMsg={"Your submission was successful. Please look out for an email confirmation."} title={"The questionnaire has been submitted"} isEng={true} Visible={true} field={new FormSectionElements()}/>
            );
            return htmlString;
        }

        if (this.state.stepperIndex == this.dashboardIndex) {
            htmlString.push(<CMADashboardComponent programContainer={p}
                isCSD={this.state.isCSD}
                showCommentStatus={p.Entity.status != TemplateStatus.ASSIGNED && p.Entity.status != TemplateStatus.IN_PROGRESS && !this.state.isCSD}
                cmaRole={cmaRole}
                callback={(p) => this.props.callback(p)}
                callbackStepIndex={(i) => this.setState({ stepperIndex: i })} 
                callbackValueSaved={()=>{this.displayToast()}}
                />);

        } else if (this.state.stepperIndex == this.reviewPageIndex) {
            htmlString.push(<CMAReviewComponent programContainer={p} callback={(p) => this.setState({showConfirmation: true})}
                callbackStepIndex={(i) => this.setState({ stepperIndex: i, fromReview: true })} 
                callbackValueSaved={()=>{this.displayToast()}}/>);

        } else {
            htmlString.push(
                <ErrorAlertComponent
                    bodyMsg={"You must accept the collection and use of information to continue."}
                    title={"Please accept the Legal Disclaimer to proceed further"}
                    isEng={true}
                    Visible={this.state.showError && this.state.stepperIndex == 0} />
            );
            htmlString.push(<Heading1>{currentSec.ENUTitle}</Heading1>);
            currentSec.ListOfFormSubSections.forEach((subsec) => {
                const subsecClone = parseJson(stringifyJson(subsec, this.props.programContainer.CategoryId), this.props.programContainer.CategoryId);
                htmlString.push(<SubSectionComponent key={'sec' + currentSec.Id + 'sub_' + subsec.Id} isEng={true}
                    activeSubSection={subsec}
                    editable={true}
                    callback={(p) => {
                        if (this.state.fromReview && this.state.subsecBool) {
                            this.setState({ initialSubsec: subsecClone ,subsecBool:false});
                        }
                        this.props.callback(p)
                    }}
                    callbackStepIndex={(i) => this.setState({ stepperIndex: i })} 
                    callbackValidate={(errors) => this.props.callbackValidate(errors)}/>);
            });
        }

        if (this.state.stepperIndex > this.reviewPageIndex && !this.state.fromReview) {
            htmlString.push(
                <button className="ontario-button ontario-button--primary"
                    onClick={() => {
                        const secList = p.ListOfFormSections;
                        let nextIndex = this.state.stepperIndex + 1;
                        // if at last category of function, go back to dashboard
                        // if (this.state.stepperIndex == (secList.length - 1) || secList[nextIndex].ENUTitle.includes("Category 1")) {
                        //     nextIndex = this.dashboardIndex;
                        // }
                        if (!this.state.isCSD){
                            CMAUtils.saveCMA(this.props.programContainer).then((success)=>{
                               if( success) this.displayToast();
                            })
                        }
                            

                        // if at last of category of all functions, go back to dashboard
                        if (this.state.stepperIndex == (secList.length - 1)) {
                            nextIndex = this.dashboardIndex;
                        }
                        this.setState({ stepperIndex: nextIndex });
                    }}>Next</button>
            );
        }

        if (this.state.stepperIndex > this.reviewPageIndex && this.state.fromReview) {
            htmlString.push(<>
                <button className="ontario-button ontario-button--primary"
                    onClick={() => {
                        this.setState({ stepperIndex: this.reviewPageIndex, fromReview: false, initialSubsec: null ,subsecBool:true});
                    }}>Save changes</button>

                <button className="ontario-button ontario-button--tertiary"
                    onClick={() => {
                        if (this.state.initialSubsec) currentSec.ListOfFormSubSections[0] = this.state.initialSubsec;
                        this.setState({ stepperIndex: this.reviewPageIndex, fromReview: false, initialSubsec: null,subsecBool:true});

                    }}>Cancel and return</button>
            </>);
        }

      htmlString.push(
            <>
                {/* @ts-ignore */}
                <Toast ref={(el) => this.growl = el} />
            </>
        )

        return htmlString;
    }

    displayToast = () => {
        this.growl.show({ severity: 'success', summary: 'saved', detail: 'Data saved' });
    }
 
}